import axios from 'axios';
import { serverUrl } from '../../ApiRoute';
import store from '../redux';

export const fetchGateways = () =>
  axios.get(`${serverUrl.vrvController}/v3/vrv/gateways`).then(r => r.data);

export const fetchIdus = (vrvGatewayId) =>
  axios.get(`${serverUrl.vrvController}/v3/vrv/idus`, { params: { vrvGatewayId } }).then(r => r.data);

export const sendBulkCommand = (payload) =>
  axios.post(`${serverUrl.vrvController}/v3/vrv/idus/bulkCommand`, payload).then(r => r.data);

const authHeaders = () => {
  const token = store.getState().login?.access;
  return { Authorization: `Bearer ${token}` };
};

export const createSchedule = async (payload) => {
  const res = await axios.post(`${serverUrl.sub}/v3/centralschedules/create`, payload, { headers: authHeaders() });
  return res.data;
};

export const fetchVrvSchedules = async (houseId) => {
  const res = await axios.post(`${serverUrl.sub}/v3/centralschedules/listByHouse`, { houseId }, { headers: authHeaders() });
  return res.data;
};

export const deleteVrvSchedule = async (scheduleId) => {
  const res = await axios.post(`${serverUrl.sub}/v3/centralschedules/remove`, { scheduleId }, { headers: authHeaders() });
  return res.data;
};

export const toggleVrvSchedule = async (scheduleId, enabled) => {
  const res = await axios.post(`${serverUrl.sub}/v3/centralschedules/update`, { scheduleId, enabled }, { headers: authHeaders() });
  return res.data;
};

export const updateVrvSchedule = async (payload) => {
  const res = await axios.post(`${serverUrl.sub}/v3/centralschedules/update`, payload, { headers: authHeaders() });
  return res.data;
};

export const sendCommand = ({ iduDeviceId, pointName, value, vrvGatewayId }) => {
  const login = store.getState().login;
  return axios.post(`${serverUrl.vrvController}/v3/vrv/idus/command`, {
    iduDeviceId,
    pointName,
    value,
    controllerType: 'savings-dashboard',
    controllerId: `${login?.profile?.first_name} (${login?.profile?.email})`,
    controllerDetails: { userId: login?.profile?._id },
    vrvGatewayId
  }).then(r => r.data);
};
